import React from "react"
import { motion } from "framer-motion"

export const CarouselProgressBar = ({ progress = "30" }) => {
  return (
    <div className="h-2 w-full bg-sand relative my-10">
      <motion.span
        className="absolute h-full top-0 left-0 bg-marphonaGold"
        style={{ width: `${progress}%` }}
        transition={{ type: "spring", damping: 50 }}
      />
    </div>
  )
}
